import makeActionCreator from 'utils/makeActionCreator';
import {
  SELECT_OPTION_ACTION,
  ACTIVE_MENU_ACTION,
} from './constants';

export const selectOptionAction = makeActionCreator(SELECT_OPTION_ACTION, 'position');
export const activeMenuAction = makeActionCreator(ACTIVE_MENU_ACTION);
